import React from 'react';
import { useSelector } from 'react-redux';

import { Icon, Spinner } from '@components';

import { MetaSyncItem, removeMetaSync } from '../metaSyncSlice';
import { META_SYNC_STATUS } from '../utils/metaIntegrationHelpers';
import ProgressPanel from './ProgressPanel';

const MetaSyncProgressPanel: React.FC = () => {
  const syncs = useSelector(
    (state: any) => state.metaSync?.items || []
  ) as MetaSyncItem[];

  const getSyncStatusIcon = (status: string) => {
    switch (status) {
      case META_SYNC_STATUS.COMPLETED:
        return <Icon name="tick-with-circle" className="text-green-500" />;
      case META_SYNC_STATUS.ERROR:
        return <Icon name="error" className="text-red-500" />;
      case META_SYNC_STATUS.PARTIAL_SUCCESS:
        return <Icon name="alert-circle" className="text-yellow-500" />;
      default:
        return <Spinner size="sm" />;
    }
  };

  const getSyncStatusMessage = (sync: MetaSyncItem): string => {
    switch (sync.status) {
      case META_SYNC_STATUS.SYNCING:
        return 'Syncing leads from Meta...';
      case META_SYNC_STATUS.COMPLETED:
        return 'Leads synced successfully';
      case META_SYNC_STATUS.PARTIAL_SUCCESS:
        return 'Leads synced partially';
      case META_SYNC_STATUS.ERROR:
        return 'Failed to sync leads from Meta.';
      default:
        return 'Syncing leads from Meta...';
    }
  };

  const getItemIcon = () => <Icon name="file" />;

  return (
    <ProgressPanel
      items={syncs}
      title="Sync from Meta"
      inProgressStatus={META_SYNC_STATUS.SYNCING}
      removeAction={removeMetaSync}
      getStatusIcon={getSyncStatusIcon}
      getStatusMessage={getSyncStatusMessage}
      getItemIcon={getItemIcon}
    />
  );
};

export default MetaSyncProgressPanel;
